
<template>
  <div class="login">
    <div class="main">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Be so kind and log in</span>
        </div>
        <div slot="">
          <el-input
            class="login-group-element"
            placeholder="Please input"
            v-model="email"
            clearable>
          </el-input>
          <el-input
            class="login-group-element"
            @keyup.enter.native="makeLogin"
            placeholder="Please input password" v-model="password" show-password>
          </el-input>
          <div class="buttons">
              <el-button type="danger" class="loginBtn" @click="makeLogin">Login</el-button>
            </div>
        </div>
        
      </el-card>
      <div class="content">
      </div>
      

      <div class="error" v-if="error">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import * as authService from '../services/auth.service';
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: ''
    }
  },

  methods: {
    makeLogin () {
      console.log(process.env);
      authService.makeLogin({
        email: this.email,
        password: this.password
      }).then(response => { this.error = ''; this.$router.push('projects')})
        .catch((error) => {
          console.log('error', error)
          this.error = error.status === 404 ? 'User with same email not found' : error.message
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.lpt-login-wrapper {
  height: 100px;
}

.loginBtn{
  width:100%;
}
.login-group-element {
  margin-bottom: 5px;
}
.login {
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;

  .main {
    padding: 30px 15px;
    background: #fff;
    width: 400px;
    
    .header {
      text-align: center;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
    }

    .error {
      background-color: red;
      padding: 10px;
      font-size: 12px;
      opacity: 1;
      transition: all 0.5s;
    }
  }
}
</style>
